import Typography from "@mui/material/Typography";
import {
  Button,
  Grid,
  TextField,
  Dialog,
  DialogContent,
  Slide,
  InputAdornment,
} from "@mui/material";
import { forwardRef } from "react";
import { Wallet, setTopupDialog } from "../../../../../app/slices/walletSlice";
import { useDispatch, useSelector } from "react-redux";
import { Controller, useForm } from "react-hook-form";
import { showNotification } from "../../../../../app/slices/notificationSlice";
import { NumericFormat } from "react-number-format";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const TopupForm = (props) => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user.user.form);
  const _Wallet = useSelector((state) => state.wallet);
  const transactionsSearchBody = useSelector(
    (state) => state.wallet.transactionsSearchBody,
  );
  const { control, handleSubmit } = useForm({
    defaultValues: {},
  });

  const onSubmit = (data) => {
    data.to_user_id = user.id;
    if (props.userData.is_representative) {
      dispatch(Wallet.topupRep(data, transactionsSearchBody)).then((x) => {
        dispatch(setTopupDialog());
      });
    } else
      dispatch(
        showNotification({
          message: "هذه العملية مخصصة للمندوب فقط",
          type: "error",
        }),
      );
  };

  const handlDialog = () => {
    dispatch(setTopupDialog());
  };

  const NumericFormatCustom = forwardRef(
    function NumericFormatCustom(props, ref) {
      const { onChange, ...other } = props;
      return (
        <NumericFormat
          {...other}
          getInputRef={ref}
          onValueChange={(values) => {
            onChange({
              target: {
                name: props.name,
                value: values.value,
              },
            });
          }}
          thousandSeparator
          valueIsNumericString
        />
      );
    },
  );

  return (
    <Dialog
      open={_Wallet.topUpDialog}
      TransitionComponent={Transition}
      keepMounted
      fullWidth={true}
      dir="rtl"
      onClose={handlDialog}
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogContent>
        <Typography
          mb={3}
          variant="h4"
          color={"purple"}
          gutterBottom
          component="div"
        >
          {"اضافة رصيد للمندوب"}
        </Typography>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={12}></Grid>
            <Grid item xs={12} md={12}>
              <Controller
                name="amount"
                control={control}
                render={({ field }) => (
                  <TextField
                    required
                    size="small"
                    label="المبلغ الكلي"
                    fullWidth
                    {...field}
                    sx={{ marginBottom: 1 }}
                    InputProps={{
                      inputComponent: NumericFormatCustom,
                      startAdornment: (
                        <InputAdornment position="start">IQD</InputAdornment>
                      ),
                    }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={12}>
              <Controller
                name="cash"
                control={control}
                render={({ field }) => (
                  <TextField
                    required
                    size="small"
                    label="المبلغ المدفوع"
                    fullWidth
                    {...field}
                    sx={{ marginBottom: 1 }}
                    InputProps={{
                      inputComponent: NumericFormatCustom,
                      startAdornment: (
                        <InputAdornment position="start">IQD</InputAdornment>
                      ),
                    }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={12}>
              <Controller
                name="note"
                control={control}
                render={({ field }) => (
                  <TextField
                    size="small"
                    label="ملاحظات"
                    fullWidth
                    multiline
                    rows={4}
                    {...field}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={12}>
              <Button type="submit" variant="contained" color="primary">
                حفظ
              </Button>
            </Grid>
          </Grid>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default TopupForm;
